<template>
  <div class="selectAccomodationCard">
    <template v-if="!selectedAccomodation">
      <h5>{{ $t('residences.card.title') }}</h5>
      <p class="subtitle">{{ $t('residences.card.subtitle') }}</p>
    </template>
    <template v-else>
      <h5 class="selectAccomodationCard__unitType">{{ selectedAccomodation.unit_type.commercial_title }}</h5>
      <p class="selectAccomodationCard__type">{{ $t('residences.card.type') }} {{ selectedAccomodation.unit_type.kind }}</p>
      <p class="selectAccomodationCard__surface">
        {{ $t('residences.card.size') }}
        <surface-display
          :offer="selectedAccomodation"
          :with-bold="true"
        />
      </p>
      <p class="selectAccomodationCard__rent">
        {{ $t('residences.card.rent') }}
        <rent-display
          :offer="selectedAccomodation"
          :with-bold="true"
        />
      </p>
      <div class="selectAccomodationCard__line">
        <div class="roomMates">
          <template v-if="selectedAccomodation.unit_type.roomates_count > 1">
            {{ $t('residences.accomodation.sharedRoomAvailable') }}
            <md-icon name="people" />
          </template>

          <template v-if="selectedAccomodation.unit_type.roomates_count === 1">
            {{ $t('residences.accomodation.sharedRoomNotAvailable') }}
            <md-icon name="person" />
          </template>
        </div>
        <div class="equiped">
          {{ $t('residences.accomodation.equiped') }}
          <md-icon
            :class="{ active: selectedAccomodation.unit_type.equipped }"
            :name="selectedAccomodation.unit_type.equipped ? 'check_circle' : 'clear'"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SurfaceDisplay from '@/components/ui/SurfaceDisplay'
import RentDisplay from '@/components/ui/RentDisplay'

export default {
  name: "SelectedAccomodationCard",
  components: {
    SurfaceDisplay,
    RentDisplay
  },
  computed: {
    ...mapState({
      selectedAccomodation: state => state.residences.selectedAccomodation
    })
  },
}
</script>

<style lang="scss" scoped>
$c: '.selectAccomodationCard';

#{$c} {
  padding: 0 10px;
  @include respond-between(xs, lg) {
    padding: 5px 30px;
  }

  h5 {
    font-size: 14px;
    font-weight: 600;
    line-height: 36px;
    color: #303133;
  }

  p {
    margin: 0;
    line-height: 1.75;
  }

  @include respond-above(lg) {
    p:not(.subtitle),
    h5,
    .roomMates,
    .equiped {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__arrow {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    color: $--color-primary;
  }

  &__line {
    margin: 8px 0;
    display: flex;
    justify-content: center;

    div {
      display: flex;
      align-items: center;

      i {
        margin-left: 6px;
      }
    }
  }

  .equiped {
    .active {
      color: $--color-success;
    }
  }
}
</style>